/* vitae · Spectrum explorer — section JS
   Instance-scoped (data-vt-sx), duplicate-safe, re-inits on shopify:section:load.
   No browser storage. Respects prefers-reduced-motion. */
(function () {
  "use strict";

  /* ── shared spectrum-column system (matches the bulb emulator / Rayleigh section) ── */
  var BAND_COLORS = ["#5512b5","#3a1fd6","#2454ff","#0a8cff","#00c2d6","#15cf57","#5fd62b","#a6d61f","#ffd21f","#ffa61a",
    "#ff6e1a","#ff3b2f","#f5261e","#df1e1e","#c41e1e","#ab1a1a","#8f1818","#7a1414","#681010"];
  var STEP = 0.5;
  function crU(p0, p1, p2, p3, u) { var u2 = u * u, u3 = u2 * u;
    return Math.max(0, 0.5 * (2 * p1 + (-p0 + p2) * u + (2 * p0 - 5 * p1 + 4 * p2 - p3) * u2 + (-p0 + 3 * p1 - 3 * p2 + p3) * u3)); }
  function resample(a) { var out = [], last = a.length - 1;
    for (var t = 0; t <= last + 1e-9; t += STEP) { var i = Math.min(last - 1, Math.floor(t)), u = t - i;
      var v = crU(a[Math.max(0, i - 1)], a[i], a[i + 1], a[Math.min(last, i + 2)], u);
      var hi = Math.max(0, a[i], a[i + 1]); out.push(Math.min(hi, v)); }
    return out; }
  function hex2rgb(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
  function rgb2hex(r) { return "#" + r.map(function (v) { return ("0" + Math.round(v).toString(16)).slice(-2); }).join(""); }
  function colorAt(t) { var last = BAND_COLORS.length - 1, i = Math.min(last - 1, Math.floor(t)), u = t - i;
    var a = hex2rgb(BAND_COLORS[i]), b = hex2rgb(BAND_COLORS[i + 1]);
    return rgb2hex([a[0] + (b[0] - a[0]) * u, a[1] + (b[1] - a[1]) * u, a[2] + (b[2] - a[2]) * u]); }
  var COLORS5 = []; for (var t5 = 0; t5 <= (BAND_COLORS.length - 1) + 1e-9; t5 += STEP) COLORS5.push(colorAt(t5));

  /* ── nature's spectra — same physics as the Rayleigh section ──
     CIE D50, Rayleigh attenuation ∝ 1/λ⁴ over the low sun's air path, firelight = 1200 K blackbody */
  var D50_10=[49.31,56.51,60.03,57.82,74.82,87.25,90.61,91.37,95.11,91.96,95.72,96.61,97.13,102.10,100.75,102.32,100.00,97.74,98.92,93.50,97.69,99.27,99.04,95.72,98.86,95.67,98.19,103.00,99.13,87.38,91.60,92.89,76.85,86.51,92.58,78.23,57.69,82.92,78.27];
  function d50(l) { var f = (l - 400) / 10, i = Math.floor(f), t = f - i; if (i < 0) return D50_10[0]; if (i >= 38) return D50_10[38];
    return D50_10[i] + (D50_10[i + 1] - D50_10[i]) * t; }
  function planck(lamNm, T) { var l = lamNm * 1e-9, h = 6.626e-34, c = 3e8, k = 1.381e-23;
    return 1 / (Math.pow(l, 5) * (Math.exp(h * c / (l * k * T)) - 1)); }
  var TAU0 = 0.205; function tauAt(l) { return TAU0 * Math.pow(550 / l, 4); }
  function airmass(elev) { var h = Math.max(elev, 0);
    return 1 / (Math.sin(h * Math.PI / 180) + 0.50572 * Math.pow(h + 6.07995, -1.36364)); }
  var CWL = []; for (var ci = 0; ci < COLORS5.length; ci++) CWL.push(420 + 10 * ci);
  var cBase = CWL.map(d50), cRefMax = Math.max.apply(null, cBase);
  function sunCurve(elev) { var m = airmass(elev);
    return CWL.map(function (l, i) { return Math.max(0, Math.min(1, cBase[i] * Math.exp(-(m - 1) * tauAt(l)) / cRefMax)); }); }
  var fireRaw = CWL.map(function (l) { return planck(l, 1200); }), fireMax = Math.max.apply(null, fireRaw);
  var fireCurve = fireRaw.map(function (v) { return 0.22 * v / fireMax; });
  /* Light symmetric smoothing for the ghostline. Raw CIE D50 carries real spectral
     structure — e.g. the deep 760 nm O2 absorption dip — which makes a plotted
     reference line spike up and down and look "broken". The ghostline is meant to
     read as a clean daylight curve, so we smooth the sun/fire curves before drawing.
     Purely visual: the match score uses each hour's fixed MDER target, not this SPD. */
  function smooth(a, passes) {
    var out = a.slice(), n = a.length; passes = passes || 4;
    for (var p = 0; p < passes; p++) {
      var s = out.slice();
      for (var i = 0; i < n; i++) {
        out[i] = 0.25 * s[Math.max(0, i - 1)] + 0.5 * s[i] + 0.25 * s[Math.min(n - 1, i + 1)];
      }
    }
    return out;
  }

  var ICONS = {
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="4.2"/><path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.3 5.3l1.7 1.7M17 17l1.7 1.7M18.7 5.3L17 7M7 17l-1.7 1.7"/></svg>',
    sunlow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6.5 16a5.5 5.5 0 0 1 11 0"/><path d="M12 6.5V4M5 9l-1.7-1.7M19 9l1.7-1.7M2.5 16h2M19.5 16h2M3.5 20h17"/></svg>',
    sunset: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M8 17a4 4 0 0 1 8 0"/><path d="M12 10V6.5M12 6.5l-2.2 2.2M12 6.5l2.2 2.2M2.5 17h2.5M19 17h2.5M4.5 21h15"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5z"/></svg>'
  };

  var TIMES = [
    { id: "day", name: "Day", icon: "sun", target: 1.00,
      nature: "Noon sun overhead", ghost: "D50 daylight", spd37: smooth(sunCurve(90)) },
    { id: "evening", name: "Evening", icon: "sunlow", target: 0.40,
      nature: "Low golden sun", ghost: "low sun · golden hour", spd37: smooth(sunCurve(12)) },
    { id: "late", name: "Late evening", icon: "sunset", target: 0.15,
      nature: "Sunset afterglow", ghost: "sun at the horizon", spd37: smooth(sunCurve(2)) },
    { id: "night", name: "Night", icon: "moon", target: 0.02,
      nature: "Firelight & moon", ghost: "firelight ≈ 1200 K", spd37: smooth(fireCurve) }
  ];

  /* SPD sampled 420..780 nm / 20 nm (19 pts). amp = display brightness vs noon daylight
     (compressed — realistic ratios would be invisible). Datasheet values, not store copy. */
  var SOURCES = [
    { id: "spectrasol", name: "Spectrasol · 5000 K", color: "#8fb4ef", k: "vitae Linear Pro · closest to the sun", mder: 0.85, amp: 0.94,
      text: "The full-spectrum flatbed in the vitae Linear Pro. Engineered to track daylight across the visible range, with a strong deep-red tail — almost the full daytime signal, by design.",
      use: "Daytime focus. At night it works against you — switch it off.",
      spd: [0.30,0.62,0.95,1.00,0.96,0.95,0.96,0.97,0.98,0.99,0.99,1.00,0.98,1.00,0.85,0.45,0.20,0.08,0.04] },
    { id: "vitae4000", name: "vitae · 4000 K", color: "#aac7ef", k: "DEN · CRI 96+", mder: 0.65, amp: 0.72,
      text: "vitae\u2019s brightest mode: a true-colour neutral white for the working day. A real blue band keeps you alert — a good daytime light, honestly not a sun replacement.",
      use: "Work & study, daytime hours.",
      spd: [0.30,0.72,0.80,0.45,0.61,0.69,0.71,0.72,0.78,0.89,0.97,1.00,0.93,0.80,0.56,0.43,0.30,0.18,0.08] },
    { id: "screen", name: "Screens", color: "#2f6bff", k: "RGB white · blue + green + red", mder: 0.78, amp: 0.45,
      text: "A screen is really just a blue, a green and a red primary. Its blue band is nearly as full as daylight — in a dark room, that is a powerful \"stay awake\" message.",
      use: "Fine by day. Not in the 90 minutes before sleep.",
      spd: [0.03,0.20,1.00,0.45,0.18,0.40,0.85,0.42,0.28,0.55,0.80,0.35,0.12,0.05,0.02,0.01,0.00,0.00,0.00] },
    { id: "vitae2000", name: "vitae · 2000 K", color: "#ff9442", k: "CRI 96+ · cosy evening", mder: 0.33, amp: 0.55,
      text: "A soft, warm white for lamp-lit nights in. The blue band is low now — your clock is easing off, though it is not yet true night light.",
      use: "Cosy evenings after sundown.",
      spd: [0.02,0.05,0.05,0.06,0.10,0.15,0.24,0.36,0.52,0.70,0.85,1.00,0.95,0.86,0.74,0.60,0.46,0.30,0.13] },
    { id: "rgborange", name: "RGB “orange”", color: "#ff8c1a", k: "green + red · fake amber", mder: 0.30, mderLow: 0.65, amp: 0.45,
      text: "A smart bulb set to “orange” fakes the colour by mixing a green and a red channel — no real amber phosphor. The number looks okay, but that green peak sits right in the wake band and still nudges your clock.",
      use: "Looks safe. Isn’t — the spectrum tells on it.",
      spd: [0.00,0.00,0.00,0.00,0.03,0.38,0.55,0.16,0.06,0.55,0.92,0.36,0.08,0.02,0.00,0.00,0.00,0.00,0.00] },
    { id: "vitae1600", name: "vitae · 1600 K", color: "#ff7e2e", k: "ENN 2.0 · CRI 94+", mder: 0.20, amp: 0.42,
      text: "A deep, warm amber-red — bedtime-story light. Rich in the reds, almost nothing in the blue-green: about the same low signal as a candle.",
      use: "Winding little ones down, late night.",
      spd: [0.00,0.01,0.03,0.04,0.05,0.08,0.11,0.15,0.21,0.30,0.40,0.55,0.66,0.56,0.73,0.70,1.00,0.25,0.05] },
    { id: "vitae1200", name: "vitae · 1200 K", color: "#e8532b", k: "orange · blue-free", mder: 0.015, amp: 0.34,
      text: "Real orange from a dedicated amber source — a hard gap where blue and green would be, so the wake band is empty. Bright enough to read or feed by; your brain still reads the room as dark.",
      use: "The last 90 minutes, and through the night.",
      spd: [0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.00,0.80,0.50,1.00,0.55,0.15,0.04,0.01,0.00,0.00,0.00,0.00] },
    { id: "candle", name: "Wax candle", color: "#e6a23c", k: "open flame · the original night light", mder: 0.20, amp: 0.14,
      text: "The light humans read by for millennia after dark. A smooth ember-red glow with an empty wake band — nature\u2019s own night spectrum, just dim and a bit of a fire hazard.",
      use: "Night — the benchmark vitae 1200 K is built to match.",
      spd: [0.00,0.01,0.02,0.03,0.05,0.08,0.12,0.18,0.26,0.36,0.48,0.62,0.76,0.88,0.96,1.00,0.98,0.95,0.92] }
  ];
  SOURCES.forEach(function (s) { s.spd37 = resample(s.spd); });

  function score(mder, target) { return Math.max(0, Math.round((1 - Math.abs(mder - target)) * 100)); }
  function grade(sc) {
    if (sc >= 80) return { hex: "#3f9d63", t: "Right light for this hour" };
    if (sc >= 55) return { hex: "#c9a13a", t: "Workable, not ideal" };
    return { hex: "#d64a2b", t: "Wrong light for this hour" };
  }

  function init(root) {
    if (root.dataset.sxInit) return;           /* duplicate-safe */
    root.dataset.sxInit = "1";
    var $ = function (k) { return root.querySelector('[data-sx="' + k + '"]'); };
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* bars */
    var barsEl = $("bars"), ghostSvg = $("ghost"), barEls = [];
    COLORS5.forEach(function (c, i) {
      var b = document.createElement("div"); b.className = "vt-sx-bar"; b.style.background = c;
      /* staggered transition-delay → on a source change the columns rise/fall in a
         smooth left-to-right wave instead of all snapping together. The height
         transition itself is in the CSS; reduced-motion disables it (transition:none). */
      if (!reduce) b.style.transitionDelay = (i * 8) + "ms";
      barsEl.insertBefore(b, ghostSvg); barEls.push(b);
    });

    /* ghostline */
    var ghostFill = $("ghost-fill"), ghostLine = $("ghost-line"), ghostLab = $("ghost-lab");
    function ghostPath(spd) {
      var n = spd.length, pts = [];
      for (var i = 0; i < n; i++) {
        var y = Math.max(0, Math.min(99.4, 100 - spd[i] * 100));
        pts.push((i / (n - 1) * 100).toFixed(2) + "," + y.toFixed(2));
      }
      var line = "M" + pts.join(" L");
      return { line: line, fill: line + " L100,100 L0,100 Z" };
    }
    function applyGhost(spd) {
      var p = ghostPath(spd);
      ghostLine.setAttribute("d", p.line); ghostFill.setAttribute("d", p.fill);
    }
    function setGhost(t) {
      ghostLab.textContent = t.ghost;
      /* Snap the ghostline to the new curve in ONE path update. Morphing the SVG
         <path> frame-by-frame (the old rAF tween) left broken / duplicated dashed
         segments during the transition on this theme — its compositor doesn't repaint
         an animating path cleanly, so intermediate frames piled up and only cleared
         once the tween finished ("smooths out in a while"). One update = one clean
         repaint. The bars still animate smoothly via their CSS height transition. */
      applyGhost(t.spd37);
    }

    /* readout */
    var matchVal = $("match"), verdictEl = $("verdict"), srcMark = $("mark"), targetMark = $("target"),
        subMder = $("mder"), subTarget = $("want"), labTime = $("time"), natureLine = $("nature"),
        dName = $("name"), dK = $("k"), dText = $("text"), dUse = $("use");
    var lastShown = 0;
    function ease(x) { return 1 - Math.pow(1 - x, 3); }
    function setMatch(target) {
      if (reduce) { matchVal.innerHTML = target + "<small>%</small>"; lastShown = target; return; }
      var start = lastShown, s0 = 0;
      function cnt(ts) {
        if (!s0) s0 = ts; var k = Math.min(1, (ts - s0) / 500);
        var val = Math.round(start + (target - start) * ease(k));
        matchVal.innerHTML = val + "<small>%</small>";
        if (k < 1) requestAnimationFrame(cnt); else lastShown = target;
      }
      requestAnimationFrame(cnt);
    }

    var curTime = TIMES[0], curSrc = SOURCES[0];
    var pillEls = [], tabEls = [];

    function render() {
      var spd = curSrc.spd37, amp = curSrc.amp;
      barEls.forEach(function (b, i) { b.style.height = (spd[i] <= 0.002 ? 0 : spd[i] * amp * 100) + "%"; });
      /* Green stays melatonin-active at low light: as rods take over they respond
         across a broad band that includes green, which the melanopic MDER under-weights.
         Sources given a `mderLow` use it as their effective circadian load in the
         Late evening + Night tabs, so a green-mixed "amber" scores as badly as it acts.
         Tune the per-source mderLow value (or add it to others) to taste. */
      var lowLight = (curTime.id === "late" || curTime.id === "night");
      var effMder = (lowLight && curSrc.mderLow != null) ? curSrc.mderLow : curSrc.mder;
      var sc = score(effMder, curTime.target), g = grade(sc);
      setMatch(sc);
      matchVal.style.color = g.hex;
      verdictEl.textContent = g.t; verdictEl.style.background = g.hex;
      subMder.textContent = effMder.toFixed(effMder >= 0.1 ? 2 : 3);
      subTarget.textContent = "~" + curTime.target.toFixed(2);
      labTime.textContent = curTime.name.toLowerCase();
      srcMark.style.left = Math.max(0, Math.min(100, effMder * 100)) + "%";
      targetMark.style.left = Math.max(0, Math.min(100, curTime.target * 100)) + "%";
      dName.textContent = curSrc.name; dK.textContent = curSrc.k; dText.textContent = curSrc.text;
      dUse.innerHTML = "<b>Best at:</b> " + curSrc.use;
      natureLine.innerHTML = "In nature right now: <b>" + curTime.nature + "</b> · <span class=\"tg\">MDER ~" + curTime.target.toFixed(2) + "</span>";
    }

    /* time tabs */
    var tabRow = $("tabs");
    TIMES.forEach(function (t, idx) {
      var b = document.createElement("button");
      b.className = "vt-sx-tab" + (idx === 0 ? " on" : ""); b.type = "button"; b.setAttribute("role", "tab");
      b.setAttribute("aria-selected", idx === 0 ? "true" : "false");
      b.innerHTML = ICONS[t.icon] + "<span>" + t.name + "</span>";
      b.addEventListener("click", function () {
        tabEls.forEach(function (c) { c.classList.remove("on"); c.setAttribute("aria-selected", "false"); });
        b.classList.add("on"); b.setAttribute("aria-selected", "true");
        curTime = t; setGhost(t); render();
      });
      tabRow.appendChild(b); tabEls.push(b);
    });

    /* source tiles */
    var srcRow = $("src");
    SOURCES.forEach(function (s, idx) {
      var b = document.createElement("button");
      b.className = "vt-sx-pill" + (idx === 0 ? " on" : ""); b.type = "button"; b.setAttribute("role", "tab");
      b.style.setProperty("--pc", s.color);
      b.innerHTML = "<span class=\"dot\"></span>" + s.name;
      b.addEventListener("click", function () {
        pillEls.forEach(function (c) { c.classList.remove("on"); });
        b.classList.add("on"); curSrc = s; render();
      });
      srcRow.appendChild(b); pillEls.push(b);
    });

    setGhost(curTime); render();
  }

  function boot(scope) { [].slice.call((scope || document).querySelectorAll("[data-vt-sx]")).forEach(init); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", function () { boot(); });
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();